<template>
  <v-container>
    <div v-if="isLoading">
      <v-progress-linear indeterminate color="#008CFF"></v-progress-linear>
      <p
        class="h2 loading-text"
      >
        読み込み中です。<br><span class="fadein">少々お待ちください。</span>
      </p>
    </div>
    <v-card
      class="mx-8 my-8 rounded-xl card flex flex-col justify-center items-center"
      color="white"
      elevation="1"
      outlined
      style="border: medium solid #707070"
      v-if="!isLoading"
    >
      <v-img
        class="pic1 mx-auto"
        src="../assets/jpg/createAccountTitle.jpg"
        max-width="500"
      >
      </v-img>
      <v-card-actions class="mb-2">
        <v-col class="flex">
          <p class="m-3 text-h6 text-center">
            SLPアカウントでのログインに成功しました<br />最後に、Liqlid内で表示させる名前を設定してください
          </p>
          <p class="mb-0 name-font">ハンドルネームを設定</p>
          <v-form v-model="valid">
            <v-row>
              <v-col class="name">
                <v-text-field
                  v-model="handlename"
                  :rules="nameRules"
                  :counter="handleNameLength"
                  placeholder="ハンドルネームを入力"
                  required
                  width="50"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-card
            v-if="false"
            class="mx-auto"
            color="#dff2e1"
            max-width="344"
            outlined
            style="border-radius: 10px"
          >
            <v-list-item class="justify-center font-weight-bold">
              ログイン中のSLPアカウント
            </v-list-item>
            <v-list-item
              style="
                background-color: #fff;
                border-radius: 10px;
                margin: 0px 10px 10px;
              "
            >
              <v-list-item-avatar size="50">
                <img alt="..." :src="this.picture" />
              </v-list-item-avatar>

              <v-list-item-title class="body-1">
                {{ this.name }}
              </v-list-item-title>
            </v-list-item>
          </v-card>
          <div class="">
            <a
              href="https://drive.google.com/file/d/13yqWr0tXj2eb8898OBl_EbukMIASPZuK/view?usp=sharing"
              target="”_blank”"
              >Liquitous Account 利用規約</a
            >、
            <a
              href="https://drive.google.com/file/d/1fSPDIhzqH4BPfpUUCPvTSGy8_d227hCP/view"
              target="”_blank”"
              >プライバシーポリシー</a
            >
            <v-checkbox
              class="checkbox"
              v-model="checkbox"
              label="上記の規約に同意します"
              style="padding-left: 0%"
            ></v-checkbox>

            <!--reseterr(),submit()-->
          </div>
        </v-col>
      </v-card-actions>
      <v-row class="px-10 py-8" justify="space-between">
        <v-card-actions class="back" style="">
          <v-btn large class="back" color="black" text href="/home">
            <span style="color: #008cff">＜</span> &nbsp; &nbsp;やり直す &nbsp;
            &nbsp;<span style="color: #008cff">＞</span>
          </v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-btn
            large
            :disabled="
              !checkbox || !handlename || handlename.length > handleNameLength
            "
            class="signupbtn"
            color="#008cff"
            @click="submit()"
            style="
              text-transform: none;
              font-family: mplus-2c-bold;
              border-width: 3px;
            "
            outlined
          >
            確認してはじめる
          </v-btn>
        </v-card-actions>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import firebase from "firebase";
import Vue from "vue";
import VueMq from "vue-mq";

Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sp: 959,
    pc: 960,
  },
  defaultBreakpoint: "pc", // customize this for SSR
});

export default {
  data() {
    return {
      checkbox: false,
      handlename: "",
      handleNameLength: Number(process.env.VUE_APP_VALUE_NAME_LENGTH || "20"),
      nameRules: [
        (v) => !!v || "名前を入力してください",
        (v) =>
          v.length <= this.handleNameLength ||
          `${this.handleNameLength}文字以下で入力してください`,
      ],
      code: this.$route.query.code,
      state: this.$route.query.state,
      name: "読み込み中...",
      picture: "",
      token: "",
      isLoading: true,
      show1: false,
      valid: false,
    };
  },
  methods: {
    /*
    async handleLogin() {
      const data = await this.$store.dispatch('auth/linkOauth', {provider: 'line', code: this.code, state: this.state})
      if (!data.success) {
        alert('ログインに失敗しました。もう一度やり直してください。')
        this.redirect()
      } else if (data.makeSignUp) {
        this.name = data.name;
        this.picture = data.picture;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.redirect()
      }
      
    },*/
    /*
    async submit(){
      const data = await this.$store.dispatch('auth/signUpOauth', {provider: 'line', state: this.state, name: this.handlename})
      if (data.success) {
        this.redirect()
      } else {
        alert('ログインに失敗しました。もう一度やり直してください。')
        this.redirect()
      }
    },*/
    async handleSLP() {
      //const nonce = localStorage.getItem(`xid:${state}`);
      const redirect_uri = "https://slp-dev.netlify.app/slp_callback"; //`${window.location.origin}/xidauthhandle`;
      const functions = firebase.functions();
      const slpLoginCallback = functions.httpsCallable("slpLoginCallback");
      const { data } = await slpLoginCallback({
        redirect_uri: redirect_uri,
        state: this.state,
        code: this.code,
      });
      if (data.customToken) {
        await this.$store.dispatch("auth/useCustomToken", data.customToken);
        this.redirect()
      } else {
        this.isLoading = false;
      }
    },
    async submit(){
      const functions = firebase.functions();
      const slpSignUp = functions.httpsCallable("slpSignUp");
      const { data } = await slpSignUp({
        name: this.handlename,
        state: this.state,
      });
      const res = await this.$store.dispatch('auth/useCustomToken', data.customToken)
      if (res.success) {
        this.redirect()
      } else {
        alert('ログインに失敗しました。もう一度やり直してください。')
        this.redirect()
      }
    },
    redirect() {
      this.$router.push("/");
    },
  },
  created: async function () {
    console.log("query");
    console.log(this.$route.query);
    this.handleSLP()
    // this.handleLogin()
    // 15秒待って、まだ読み込み中ならエラー
  },
};
</script>
<style scoped>
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.loading-text {
  animation: fade 1s ease-in-out 0s 1 normal forwards;
  margin-top: 1rem;
  text-align: center;
  font-size: 1.5rem;
}
.fadein {
  animation: fade 1s ease-in-out 2s 1 normal forwards;
}
</style>